"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLoginInfoTable = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.UserLoginInfoTable = styled_components_1.default.table `
  tr {
    td:first-child {
      text-align: right;
      padding-right: 10px;
      padding-top: 2px;
      font-weight: bold;
    }
  }
`;
//# sourceMappingURL=user-login-info-table.js.map